'use strict';
 /**
 * @author Maxim Seredkin
 */
import angular from "angular";
import WelcomeController from "./controller/welcomeController";
import WelcomeInfoDirective from "./directive/welcomeInfo";
import SecurityService from '../../service/security';

export default angular.module('investmentProject.welcome', [])
    .controller('WelcomeController', WelcomeController)
    .directive('welcomeInfo', WelcomeInfoDirective)
    .factory('SecurityService', SecurityService)
    .name;
